import { Avatar, useIsMobile } from '@acceso/design-system';
import { Popover, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { MutableRefObject } from 'react';

import { useGravatarURL } from '../../../gravatar/api/get-gravatar';
import { useMe } from '../../api/get-me';
import { UserMenu } from '../UserMenu/UserMenu';

export interface UserPopoverProps {
  showUserMenu: boolean;
  close: () => void;
  toggle: () => void;
  avatarRef: MutableRefObject<HTMLDivElement | null>;
  menuRef: MutableRefObject<HTMLDivElement | null>;
  popoverPosition?: 'top' | 'bottom';
}

export function UserPopover({
  toggle,
  close,
  avatarRef,
  menuRef,
  showUserMenu,
  popoverPosition = 'bottom',
}: UserPopoverProps) {
  const isMobile = useIsMobile();
  const { data: me } = useMe();
  const { data: avatarUrl } = useGravatarURL({ email: me?.email });

  if (isMobile) {
    return (
      <div className="relative">
        <div className="cursor-pointer" onClick={toggle} ref={avatarRef}>
          <Avatar
            className="h-[32px] w-[32px]"
            user={{
              first_name: me?.first_name,
              last_name: me?.last_name,
              email: me?.email,
              username: me?.username,
              avatar: avatarUrl || null,
            }}
          />
        </div>
        {showUserMenu && (
          <div className="absolute right-0 min-w-[184px] max-w-[300px] rounded-md bg-reverse-bg-neutral-30 text-white shadow">
            <UserMenu close={close} ref={menuRef} className="p-4" />
          </div>
        )}
      </div>
    );
  }

  return (
    <Popover className="relative">
      <div className="cursor-pointer" onClick={toggle} ref={avatarRef}>
        <Avatar
          className="h-[32px] w-[32px]"
          user={{
            first_name: me?.first_name,
            last_name: me?.last_name,
            email: me?.email,
            username: me?.username,
            avatar: avatarUrl || null,
          }}
        />
      </div>

      <Transition
        show={showUserMenu}
        as={Popover.Panel}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
        className={clsx(
          'absolute min-w-[184px] max-w-[300px] rounded-md bg-reverse-bg-neutral-30 p-size-16 text-white shadow',
          popoverPosition === 'bottom' ? 'right-0 top-9' : 'bottom-full left-0 mb-2'
        )}
      >
        <UserMenu close={close} ref={menuRef} />
      </Transition>
    </Popover>
  );
}
